import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import PageHeader from '../../../Components/PageHeader';
import PageLayout from '../../../Components/LayoutComponents/PageLayout';
import { Button, Col, Row, Table } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { downlaod_pdf, get_AuditView } from '../../../Services/employee';
import moment from 'moment';
import GoBack from '../../../Components/GoBackButton/GoBack';

const AuditTabView = () => {
    const location = useLocation();
    const { id } = location.state || {}; // Access the state passed from the previous route
    const activeKey = location?.state?.activeKey;
    function blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    const history = useHistory();
    console.log(location?.state, 'sss')
    const handleDownloadPdf = async () => {
        try {
            const eventId = id
            const response = await downlaod_pdf({ id: eventId });
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Audit Report - ${id}.pdf`;
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Error exporting data:', error);
        }

    };
    const [auditData, setAuditData] = useState({
        dateTime: '',
        auditor: '',
        location: '',
        supervisor: '',
        subDepartment: '',
        customer: '',
        auditTemplate: '',
        workDescription: '',
        categories: [], // Store categories here,
        EventComments: ''

    });

    const fetchAuditData = async () => {
        try {
            if (!id) {
                console.error('Audit ID is not provided.');
                return;
            }
            const response = await get_AuditView({ id });
            if (response?.httpStatus === 200 && response.data) {
                { console.log(response, 'res') }
                setAuditData({
                    dateTime: moment?.utc(response?.data?.Event?.createdAt).format('MM-DD-YYYY') || 'N/A',
                    AuditTime:response?.data?.Event?.AuditTime,
                    auditor: response?.data?.Event?.Auditor?.firstName + " " + response?.data?.Event?.Auditor?.lastName || 'N/A',
                    location: response?.data?.Event?.TGSLocation?.name || 'N/A',
                    supervisor: response?.data?.Event?.Supervisor?.firstName + " " + response?.data?.Event?.Supervisor?.lastName || 'N/A',
                    subDepartment: response?.data?.Event?.SubDepartment?.name || 'N/A',
                    customer: response?.data?.Event?.Customer || 'N/A',
                    auditTemplate: response?.data?.Event?.TestingAudit_Template?.name || 'N/A',
                    workDescription: response?.data?.Event?.WorkDescription || 'N/A',
                    categories: response?.data?.categories || [], // Store categories from the API response
                    EventDescription: response?.data?.Event?.EventComments || "N/A"
                });
        } else {
            console.error('Failed to fetch audit data.');
        }
    } catch (error) {
        console.error('Error fetching audit data:', error);
    }
};

useEffect(() => {
    fetchAuditData();
}, [id]);

const columns = (categoryName) => [
    {
        title: categoryName, // Use the dynamic category name here
        dataIndex: 'Requirement',
        key: 'Requirement',
        width: 600
    },
    {
        title: 'Result',
        dataIndex: 'Result',
        key: 'Result',
        width: 200
    },
    {
        title: 'Comments',
        dataIndex: 'Comments',
        key: 'Comments',
    },
];

return (
    <>
        <PageLayout className="Liq-Container">
            <Grid className="PagesFrame" style={{}}>
                <PageHeader />
                <div id="PageTitle">TGS Safety Audit</div>
                <Grid style={{ display: 'flex', margin: '0px', justifyContent: 'space-between', alignItems: 'center' }}>
                    <GoBack path="/safety-testing" state={{ activeKey: location?.state?.activeKey }} />
                    <Button style={{ background: '#2963AD', color: 'white', height: '32px', marginLeft: 'auto' }} onClick={() => handleDownloadPdf(id)} >Download Audit PDF</Button>
                </Grid>
                {console.log(auditData, 'auditData')}
                <Row style={{ width: '95%', marginTop: '20px' }} gutter={[8, 10]}>
                    <Col span={12}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Date/Time:</span>
                        {auditData?.dateTime + " / " + auditData?.AuditTime}
                    </Col>
                    <Col span={12}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Auditor:</span>
                        {auditData.auditor}
                    </Col>
                    <Col span={12}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Location:</span>
                        {auditData.location}
                    </Col>
                    <Col span={12}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Foreman/Supervisor:</span>
                        {auditData.supervisor}
                    </Col>
                    <Col span={12}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>SubDepartment:</span>
                        {auditData.subDepartment}
                    </Col>
                    <Col span={12}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Customer:</span>
                        {auditData.customer}
                    </Col>
                    <Col span={24}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Audit Template:</span>
                        {auditData.auditTemplate}
                    </Col>
                    <Col span={24}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>Description of Work:</span>
                        {auditData.workDescription}
                    </Col>
                    <Col span={24}>
                        <span style={{ fontWeight: 'bold', marginRight: '8px', textDecoration: 'underline' }}>Audit comments:</span><br />
                        {auditData?.EventDescription}
                    </Col>
                </Row>
                <Grid style={{ width: '100%', marginTop: '50px' }}>
                    {auditData.categories.map((category, index) => (
                        <div key={index} style={{ marginBottom: '20px' }}>
                            <Table
                                columns={columns(category.name)}
                                dataSource={category?.TestingAudit_ItemLists?.map(item => ({
                                    Requirement: item.Description,
                                    Result: item?.TestingAudit_Results?.[0]?.Result || 'N/A',
                                    Comments: item?.TestingAudit_Results?.[0]?.Comments || 'N/A',
                                }))}
                                pagination={false} // Disable pagination

                            />
                        </div>
                    ))}
                </Grid>
            </Grid>



        </PageLayout >
    </>
);
};

export default AuditTabView;
